module.exports = __webpack_public_path__ + "static/img/broken_egg.3258e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xiangyun/broken_egg.png
// module id = Q4RI
// module chunks = 1